"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// /**
//  * @deprecated Используйте SendingsFallbacksGetManyRequestDto
//  */
// export type FindSendingsFallbackEntityDTO = SendingsFallbacksGetManyRequestDto
//# sourceMappingURL=SendingsFallbacks.js.map